<template>
  <div>
    <loader v-if="isLoading" />
    <tile-grid v-else>
      <snapshot-tile
        v-for="snapshot in $store.state.snapshot.snapshots"
        :key="snapshot.id"
        :snapshot="snapshot"
        @tile-clicked="tileClicked(snapshot)"
      >
      </snapshot-tile>
    </tile-grid>
  </div>
</template>

<script>
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import { mapActions, mapMutations, mapState } from 'vuex';
import Loader from '@/components/utils/Loader.vue';
import eventBus from '@/components/utils/slideout-panel/eventBus';
import SnapshotTile from '@/components/snapshots/SnapshotTile.vue';
import * as types from '@/store/mutation-types';
import ProjectSettingsPanel from '@/components/snapshots/ProjectSettingsPanel.vue';
import TileGrid from '@/components/utils/TileGrid';


export default {
  name: 'ChangeProject',
  components: { TileGrid, SnapshotTile, Loader },
  data() {
    return {
      isLoading: false,
      breadcrumbs: [
        {
          text: this.$t('change-project'),
        },
      ],
    };
  },
  computed: {
    ...mapState('app', [
      'project',
    ]),
  },
  methods: {
    ...mapActions('snapshot', [
      'loadSnapshots',
    ]),
    reloadSnapshots() {
      this.isLoading = true;
      this.loadSnapshots().then(() => {
        this.isLoading = false;
      });
    },
    ...mapMutations('snapshot', {
      setCurrentSnapshot: types.SET_CURRENT_SNAPSHOT,
    }),
    tileClicked(snapshot) {
      if (this.project.isEditModeEnabled) {
        this.showProjectPanel(snapshot);
      } else {
        this.setCurrentSnapshot(snapshot);
      }
    },
    showProjectPanel(snapshot) {
      this.$showPanel({
        component: ProjectSettingsPanel,
        width: '500px',
        keepAlive: false,
        props: {
          snapshot,
        },
      });
    },
  },
  created() {
    eventBus.$on('refreshSnapshots', this.reloadSnapshots);
    this.reloadSnapshots();
  },
  destroyed() {
    eventBus.$off('refreshSnapshots');
  },
  mixins: [
    BreadcrumbsManager,
  ],
};
</script>

<style scoped>

</style>
